import { createAction, createSlice } from "@reduxjs/toolkit";
import groupService from "../service/group.service";
import { updateUser } from "./users";
import { updatePayload } from "../utils/checkUpdateGroup";
import localStorageService from "../service/http.localStorage";
import { asList, readContent, replaceById } from "../utils/readContent";

const groupsSlice = createSlice({
  name: "groups",
  initialState: {
    entities: null,
    isLoading: false,
    error: null,
    dataLoaded: false,
    isComplete: false,
  },
  reducers: {
    groupsRequested: (state) => {
      state.isLoading = true;
    },
    groupsReceived: (state, action) => {
      state.entities = action.payload;
      state.isLoading = false;
      state.dataLoaded = true;
    },
    groupCreateReceived: (state, action) => {
      state.entities = replaceById(state.entities, action.payload);
      state.isLoading = false;
    },
    groupsRequestFailed: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    groupLoggedOut: (state) => {
      state.entities = null;
      state.dataLoaded = false;
      state.isLoading = false;
      state.isComplete = false;
    },
    groupRemoved: (state, action) => {
      state.entities = state.entities.filter(
        (c) => c._id !== action.payload._id
      );
      state.isComplete = false;
    },
    groupsUpdateSuccessed: (state, action) => {
      state.entities = replaceById(state.entities, action.payload);
      state.isLoading = false;
      state.isComplete = action.payload?.status === "play";
    },
  },
});

const { reducer: groupsReducer, actions } = groupsSlice;

const {
  groupsRequested,
  groupsReceived,
  groupsRequestFailed,
  groupCreateReceived,
  groupsUpdateSuccessed,
  groupLoggedOut,
  groupRemoved,
} = actions;

const addGroupRequested = createAction("groups/addGroupRequested");
const removeGroupRequested = createAction("groups/removeGroupRequested");

export const loadGroupsList = () => async (dispatch) => {
  dispatch(groupsRequested());
  try {
    dispatch(groupsReceived(asList(await groupService.get())));
  } catch (error) {
    dispatch(groupsRequestFailed(error.message));
  }
};

export const getGroupByName = (name) => (state) => {
  if (state.groups.entities) {
    return state.groups.entities.find(
      (elem) => elem.teamname.toLowerCase() === name.toLowerCase()
    );
  }
};

export const deleteGroup = (payload) => async (dispatch) => {
  dispatch(removeGroupRequested());
  try {
    const { content } = await groupService.delete(payload);
    // Удаляем из localStorage
    localStorage.removeItem("group-local-id");
    dispatch(groupRemoved(content));
  } catch (error) {
    dispatch(groupsRequestFailed(error.message));
  }
};

export const getGroupsList = () => (state) => state.groups.entities;

export const getCurrentGroup = () => (state) => {
  const groupId = localStorageService.getGroupId();

  if (!state.groups.entities) return null; // если данных нет, возвращаем null
  return state.groups.entities.find((u) => u._id === groupId) || null;
};

export const getGroupById = (groupId) => (state) => {
  if (state.groups.entities) {
    return state.groups.entities.find((u) => u._id === groupId);
  }
};
// создание группы
export const createGroup =
  ({ newData, currentUser }) =>
  async (dispatch) => {
    dispatch(addGroupRequested());
    try {
      const content = readContent(await groupService.create(newData));
      if (!content || content._id == null) {
        dispatch(groupsRequestFailed("empty"));
        return null;
      }
      dispatch(groupCreateReceived(content));
      dispatch(updateUser({ ...currentUser, teamId: content._id }));
      return content;
    } catch (error) {
      dispatch(groupsRequestFailed(error.message));
    }
  };
// Создание рандомной группы знакомства
export const createRandomGroup =
  ({ newData, currentUser }) =>
  async (dispatch) => {
    dispatch(addGroupRequested());
    try {
      const content = readContent(await groupService.createRandom(newData));
      if (!content || content._id == null) {
        dispatch(groupsRequestFailed("empty"));
        return null;
      }
      dispatch(groupCreateReceived(content));
      dispatch(updateUser({ ...currentUser, teamId: content._id }));
      return content;
    } catch (error) {
      console.log("error", error, "1", error?.response.data.error?.message);
      dispatch(
        groupsRequestFailed(
          error?.response.data.error.message
            ? error?.response.data.error.message
            : error?.message
        )
      );
    }
  };

export const setGroupErrorNull = (payload) => async (dispatch) => {
  dispatch(groupsRequested());
  dispatch(groupsRequestFailed(payload));
};

export const updateGroup = (payload) => async (dispatch) => {
  dispatch(groupsRequested());
  try {
    const newPayload = updatePayload(payload);
    const content = readContent(await groupService.update(newPayload));
    if (!content || content._id == null) {
      dispatch(groupsRequestFailed("empty"));
      return null;
    }
    dispatch(groupsUpdateSuccessed(content));
    return content;
  } catch (error) {
    dispatch(groupsRequestFailed(error.message));
    return null;
  }
};

// export const updateGroupBefore = (payload) => async (dispatch) => {
//   dispatch(groupsRequested());
//   try {
//     const newPayload = updatePayload(payload);
//     const { content } = await groupService.updateGroup(newPayload);
//     dispatch(groupsUpdateSuccessed(content));
//   } catch (error) {
//     dispatch(groupsRequestFailed(error.message));
//   }
// };

export const logOutGroup = () => (dispatch) => {
  dispatch(groupLoggedOut());
};

export const getDataLoaded = () => (state) => state.groups.dataLoaded;

export const getGroupsLoadingStatus = () => (state) => state.groups.isLoading;

export const getGroupError = () => (state) => state.groups.error;

export default groupsReducer;
